import { z } from "zod";
import type { Allergen } from "./constants";
import type { DishNutrition } from "./nutrition";

// The recipe of a menu product (food database, phase 3; docs/BAZA_INGREDIENTE.md): basic foods or products and
// their grams, declared by the restaurant. The values come from src/shared/nutrition.ts, never from an AI.

export const RECIPE_MAX_LINES = 40;

export const recipeSaveSchema = z.object({
  lines: z
    .array(
      z.object({
        kind: z.enum(["food", "product", "base"]),
        id: z.string().trim().min(1).max(80),
        grams: z.number().positive().max(5000),
      }),
    )
    .max(RECIPE_MAX_LINES),
  /** The weight served (after cooking), when the restaurant knows it. */
  cookedGrams: z.number().positive().max(10000).nullable(),
});
export type RecipeSave = z.infer<typeof recipeSaveSchema>;

export interface RecipeLineDto {
  kind: "food" | "product" | "base";
  id: string;
  name: string;
  brand: string | null;
  grams: number;
  allergens: Allergen[];
  /** Shared product data nobody checked yet: the label photo is asked for. */
  needsLabel: boolean;
}

export interface RecipeDto {
  lines: RecipeLineDto[];
  cookedGrams: number | null;
  /** Proposed by the AI and not verified by the restaurant yet: "Generat cu AI, neverificat". */
  aiUnverified: boolean;
  /** Ingredients the AI named but the database does not have yet ("de completat"). */
  missing: string[];
  /** null when the recipe is empty. */
  nutrition: DishNutrition | null;
}
